import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  flex-direction: column;
  padding: 1.8rem 0 1rem;

  h2 {
    margin: 1rem 0;
  }

  .info-text {
    max-width: 38.625rem;
    text-align: center;
    font-family: ${({ theme }) => theme.fonts.workSans};
    margin-bottom: 3.687rem;
  }

  .link-text {
    margin-left: 0.25rem;
    color: ${({ theme }) => theme.colors.blue4};
    font-weight: 700;
  }
`;
